import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a27ae752&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ae752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a27ae752')) {
      api.createRecord('a27ae752', component.options)
    } else {
      api.reload('a27ae752', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a27ae752&scoped=true&", function () {
      api.rerender('a27ae752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/comp/Accordion.vue"
export default component.exports